export default __webpack_public_path__ + "static/media/Flag_of_Iceland.110ed3b9.svg";